import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'jhi-contenuti-legali',
  templateUrl: './contenuti-legali.component.html',
  styleUrls: ['./contenuti-legali.component.scss']
})
export class ContenutiLegaliComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
